import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { Nillable } from '@web/utils';
import { PublicOrderItemComponentAttributeResponse } from './public-order-item-component-attribute.response';
import { PublicOrderItemComponentSourceResponse } from './public-order-item-component-source.response';

@jsonObject
export class PublicOrderItemComponentResponse {
  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Number)
  public readonly quantity!: number;

  @jsonMember(MultimediaResponse)
  public readonly featuredFile?: Nillable<MultimediaResponse>;

  @jsonMember(PublicOrderItemComponentSourceResponse)
  public readonly source?: Nillable<PublicOrderItemComponentSourceResponse>;

  @jsonArrayMember(PublicOrderItemComponentAttributeResponse)
  public readonly attributes?: Nillable<
    PublicOrderItemComponentAttributeResponse[]
  >;
}
